import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PasswordInput } from "@/components/ui/password-input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { PasswordStrengthMeter, FieldError } from "@/components/FormFeedback";
import { cn } from "@/lib/utils";

// "Add Receptionist" dialog — name/email/temp password form with live email
// duplicate check and password strength meter. All state owned by the parent.
export default function CreateStaffDialog({
  open,
  onOpenChange,
  form,
  setForm,
  createTouched,
  setCreateTouched,
  createFieldErrors,
  createIsValid,
  createEmailStatus,
  onCreate,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="create-staff-modal">
        <DialogHeader>
          <DialogTitle>Add Receptionist</DialogTitle>
          <DialogDescription>Create a new receptionist account for your clinic with a temporary password.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <Label>Name</Label>
            <Input data-testid="staff-name-input" value={form.name} onBlur={() => setCreateTouched((t) => ({ ...t, name: true }))} className={cn(createTouched.name && createFieldErrors.name && "border-red-500 focus-visible:ring-red-500")} onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))} />
            {createTouched.name && <FieldError testId="staff-name-error" message={createFieldErrors.name} />}
          </div>
          <div>
            <Label>Email</Label>
            <Input data-testid="staff-email-input" type="email" value={form.email} onBlur={() => setCreateTouched((t) => ({ ...t, email: true }))} className={cn(createTouched.email && createFieldErrors.email && "border-red-500 focus-visible:ring-red-500")} onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))} />
            {createTouched.email && createFieldErrors.email ? (
              <FieldError testId="staff-email-error" message={createFieldErrors.email} />
            ) : (
              createEmailStatus && form.email && (
                <p data-testid="staff-email-status" className={`mt-1 text-xs ${createEmailStatus.available ? "text-green-600" : "text-red-600"}`}>
                  {createEmailStatus.available ? "Email is available" : "This email is already registered"}
                </p>
              )
            )}
          </div>
          <div>
            <Label>Temporary Password</Label>
            <PasswordInput testId="staff-temp-password-input" value={form.temp_password} onBlur={() => setCreateTouched((t) => ({ ...t, temp_password: true }))} className={cn(createTouched.temp_password && createFieldErrors.temp_password && "border-red-500 focus-visible:ring-red-500")} onChange={(e) => setForm((f) => ({ ...f, temp_password: e.target.value }))} />
            <PasswordStrengthMeter password={form.temp_password} />
            {createTouched.temp_password && <FieldError testId="staff-temp-password-error" message={createFieldErrors.temp_password} />}
          </div>
          <div>
            <Label>Confirm Temporary Password</Label>
            <PasswordInput testId="staff-temp-password-confirm-input" value={form.temp_password_confirm} onBlur={() => setCreateTouched((t) => ({ ...t, temp_password_confirm: true }))} className={cn(createTouched.temp_password_confirm && createFieldErrors.temp_password_confirm && "border-red-500 focus-visible:ring-red-500")} onChange={(e) => setForm((f) => ({ ...f, temp_password_confirm: e.target.value }))} />
            {createTouched.temp_password_confirm && <FieldError testId="staff-temp-password-confirm-error" message={createFieldErrors.temp_password_confirm} />}
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button data-testid="create-staff-submit-btn" disabled={!createIsValid} className="bg-teal-700 hover:bg-teal-800" onClick={onCreate}>Create</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
